import { memo } from 'react'
import { locales } from '../../../../locales/en'
import type { IconProps } from '../../../Icons'
import Recommendation from '../../../Icons/Recommendation'
import { palette } from '../../../styles/colors'
import Container from '../Container'

interface RecommendationBadgeProps extends IconProps {
    shadow?: boolean
    size?: number
}

const RecommendationBadge = memo((props: RecommendationBadgeProps) => {
    const { shadow, size = 0.8, ...other } = props

    return (
        <Container title="Recommendation" shadow={shadow}>
            <Recommendation
                title={locales.settings.pinToTop.modelsYouMayLike}
                color={palette.badgeModelYouMayLike}
                size={size}
                filled
                {...other}
            />
        </Container>
    )
})

export default RecommendationBadge
export { RecommendationBadge }
